import { ApiResponse } from "@/interfaces/api-response";
import { Artwork } from "@/interfaces/artwork.interface";
import apiClient, { CustomAxiosRequestConfig } from "@/utils/axios";

const SERVICE_ENDPOINT = "artworks";

const getOneByIdNoToast = async (id: string) => {
  try {
    const response = await apiClient.get<ApiResponse<Artwork>>(
      `/${SERVICE_ENDPOINT}/${id}`,
      {
        hideToast: true,
      } as CustomAxiosRequestConfig,
    );
    return response?.data;
  } catch (error) {
    console.log("Error fetching artwork by ID:", error);
    return null;
  }
};
const getOneById = async (id: string) => {
  const response = await apiClient.get<ApiResponse<Artwork>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const getMany = async (params: {
  page: number;
  size: number;
  search?: string;
}) => {
  const { page, size, search } = params;
  const response = await apiClient.get<ApiResponse<Artwork[]>>(
    `/${SERVICE_ENDPOINT}`,
    {
      params: {
        page,
        size,
        search,
      },
    },
  );
  return response.data;
};

const getOne = async (id: string) => {
  const response = await apiClient.get<ApiResponse<Artwork>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const createOne = async (
  data: Partial<Artwork & { createTemplateDefault?: boolean }>,
) => {
  const response = await apiClient.post<{ data: Artwork }>(
    `/${SERVICE_ENDPOINT}`,
    data,
  );
  return response.data.data;
};

const updateOne = async (id: string, data: Partial<Artwork>) => {
  const response = await apiClient.put<Artwork>(
    `/${SERVICE_ENDPOINT}/${id}`,
    data,
  );
  return response.data;
};
const cloneArtwork = async (id: string) => {
  const response = await apiClient.post<Artwork>(
    `/${SERVICE_ENDPOINT}/${id}/clone`,
  );
  return response.data;
};

const deleteOne = async (id: string) => {
  const response = await apiClient.delete<ApiResponse<Artwork>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const artworkApi = {
  getOneById,
  getMany,
  getOne,
  createOne,
  updateOne,
  cloneArtwork,
  deleteOne,
  getOneByIdNoToast,
};

export default artworkApi;
